module.exports = __webpack_public_path__ + "vu.svg?4acd098aefe4ed4e16453f4d669d247e";